import {
    OnInit,
    Component,
    EventEmitter,
    forwardRef,
    Input,
    Output,
    Inject,
    ViewChild,
    ElementRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { ThemeService } from 'src/app/services/ThemeService';

@UntilDestroy()
@Component({
    selector: 'stInput',
    templateUrl: './st-input.template.html',
    styleUrls: ['./st-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StInputComponent),
            multi: true,
        },
    ],
    standalone: false,
})
export class StInputComponent implements OnInit, ControlValueAccessor {
    @ViewChild('input') inputElement: ElementRef;

    @Input() name: string;
    @Input() innerId: string;
    @Input() type: string;
    @Input() class: string;
    @Input() style: string;
    @Input() placeholder = '';
    @Input() autocomplete: string;
    @Input() min: number;
    @Input() max: number;
    @Input() step: number;
    @Input() isRequired: boolean = false;
    @Input() isDisabled: boolean = false;
    @Input() isInvalid: boolean = false;
    @Output() ngBlur = new EventEmitter();

    public theme: string;

    constructor(@Inject(ThemeService) private themeService: ThemeService) {}

    onChange: any = () => {};
    onTouch: any = () => {};
    val = '';

    ngOnInit() {
        this.theme = this.themeService.theme.id;

        this.themeService.themeObs$
            .pipe(untilDestroyed(this), distinctUntilChanged())
            .subscribe((theme) => {
                if (theme) {
                    this.theme = this.themeService.theme.id;
                }
            });
    }

    focus() {
        this.inputElement?.nativeElement.focus();
    }

    onBlur() {
        this.ngBlur.emit();
    }

    set value(val: string) {
        if (val !== undefined && this.val !== val) {
            this.val = val;
            this.onChange(val);
            this.onTouch(val);
        }
    }

    writeValue(value: string) {
        this.value = value;
    }

    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouch = fn;
    }

    get aggregatedClass(): string {
        let _class = 'form-control';
        const isInvalid = this.isInvalid || (this.isRequired && !this.val);
        if (isInvalid) _class += ' isInvalid';
        if (this.class) _class += ` ${this.class}`;
        return _class;
    }

    isPasswordVisible = false;
    get effectiveType(): string {
        return this.type === 'password'
            ? this.isPasswordVisible
                ? 'text'
                : 'password'
            : this.type;
    }

    togglePasswordVisibility(): void {
        this.isPasswordVisible = !this.isPasswordVisible;
    }
}
